// extracted by mini-css-extract-plugin
export default {"base":"SVGIcon_base__V3KN7"};